export type AgencyRegister = {
  CompanyName: string;
  CompanyCity: string;
  CompanyAddress: string;
  CompanyPostal: string;
  AgentForename: string;
  AgentSurname: string;
  AgentEmail: string;
  AgentPhone: string;
  CruiselineForename: string;
  CruiselineSurname: string;
  CruiselineEmail: string;
};

export function createAgentDef(): AgencyRegister {
  return {
    CompanyName: "",
    CompanyCity: "",
    CompanyAddress: "",
    CompanyPostal: "",
    AgentForename: "",
    AgentSurname: "",
    AgentEmail: "",
    AgentPhone: "",
    CruiselineForename: "",
    CruiselineSurname: "",
    CruiselineEmail: "",
  };
}
